import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

import { inject, ref } from "vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { useI18n } from "vue-i18n";
import SimpleForm from "@/components/SimpleForm.vue";
import AccountService from "@/projects/tenant/modules/accounts/services/AccountService";
import AccountInjectionKeys from "@/projects/tenant/modules/accounts/types/AccountInjectionKeys";
import UserService from "@/projects/tenant/modules/users/services/UserService";
import { LanguageCodes } from "@/core/types/LanguageTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateReferralCodeForAccount',
  emits: ["fetchData"],
  setup(__props, { expose: __expose, emit: emits }) {

const modalRef = ref();
const { t } = useI18n();
const ruleFormRef = ref();
const isLoading = ref(true);
const formData = ref({} as any);
const accountDetails = inject<any>(AccountInjectionKeys.ACCOUNT_DETAILS, {});

const accountTypeOptions = ref<{ label: string; value: number }[]>([]);
const languageCodes = LanguageCodes.activated;



const resetForm = async () => {
  formData.value = {
    partyId: accountDetails.value.partyId,
    accountId: accountDetails.value.id,
    name: "",
    serviceType: 400,
    accountTypes: [],
    language: LanguageCodes.enUS,
  };

  ruleFormRef.value?.resetFields();
};

const rules = ref({
  name: [
    {
      required: true,
      message: "Please input code name",
      trigger: "blur",
    },
  ],
  serviceType: [
    {
      required: true,
      message: "Please select service type",
      trigger: "change",
    },
  ],
  accountTypes: [
    {
      required: true,
      type: "array",
      min: 1,
      message: "Please select at least one account type",
      trigger: "change",
    },
  ],
  language: [
    {
      required: true,
      message: "Please select language",
      trigger: "change",
    },
  ],
});

// 拉取该账号可用的账户类型，按 accountType 去重生成多选项
const fetchAccountTypes = async () => {
  try {
    const res = await AccountService.getAccountTypeAvailable(
      accountDetails.value.id
    );
    // value 是账户类型数组，如 [4, 6, 12, 22]
    const types: number[] = Array.isArray(res?.value) ? res.value : [];
    accountTypeOptions.value = types.map((type) => ({
      label: t("type.account." + type),
      value: Number(type),
    }));
  } catch (error) {
    MsgPrompt.error(error);
  }
};

// 默认取该用户的 language
const fetchUserLanguage = async () => {
  try {
    if (!accountDetails.value.partyId) return;
    const userInfo = await UserService.getUserInfoByPartyId(
      accountDetails.value.partyId
    );
    if (userInfo?.language) {
      formData.value.language = userInfo.language;
    }
  } catch (error) {
    // 拿不到就用默认 en-us
    console.warn("fetch user language failed", error);
  }
};

const buildSummary = () => ({
  name: formData.value.name,
  code: null,
  allowAccountTypes: formData.value.accountTypes.map((type: number) => ({
    optionName: t("type.account." + type),
    accountType: type,
    pips: null,
    commission: null,
  })),
  language: formData.value.language,
  siteId: accountDetails.value.siteId,
});

const submit = async () => {
  if (
    !formData.value.name ||
    !formData.value.serviceType ||
    !formData.value.accountTypes?.length
  ) {
    MsgPrompt.warning(t("tip.pleaseCompleteAllRequiredFields"));
    return;
  }

  try {
    isLoading.value = true;
    await AccountService.addReferralCode({
      partyId: formData.value.partyId,
      accountId: formData.value.accountId,
      name: formData.value.name,
      serviceType: formData.value.serviceType,
      summary: JSON.stringify(buildSummary()),
    });

    MsgPrompt.success("ReferralCode created successfully").then(() => {
      hide();
      emits("fetchData");
    });
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};
const show = async () => {
  await resetForm();
  modalRef.value?.show();
  isLoading.value = true;
  await Promise.all([fetchAccountTypes(), fetchUserLanguage()]);
  isLoading.value = false;
};

const hide = () => {
  modalRef.value?.hide();
};

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: _ctx.$t('fields.referralCode'),
    "is-loading": isLoading.value,
    submit: submit
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: formData.value,
        rules: rules.value,
        "label-width": "160px",
        class: "demo-ruleForm",
        "status-icon": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "Service Type",
            prop: "serviceType"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formData.value.serviceType,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.serviceType) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    key: "IB",
                    label: "IB",
                    value: 300
                  }),
                  _createVNode(_component_el_option, {
                    key: "Client",
                    label: "Client",
                    value: 400
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Name",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.name) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.lang'),
            prop: "language"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formData.value.language,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.language) = $event)),
                class: "w-100"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languageCodes), (code) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: code,
                      label: _ctx.$t('type.language.' + code),
                      value: code
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.accountType'),
            prop: "accountTypes"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox_group, {
                modelValue: formData.value.accountTypes,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.accountTypes) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accountTypeOptions.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_checkbox, {
                      key: item.value,
                      label: item.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model", "rules"])), [
        [_directive_loading, isLoading.value]
      ])
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}
}

})